<div class="p-3">
  <h2>Select Target Item Set</h2>
  <p>Select the item set where you want to move/copy the selected items:</p>

  <div class="dropdown-wrapper">
    <p-dropdown 
      [options]="filteredItemSets"
      optionLabel="name"
      optionValue="id"
      [(ngModel)]="selectedSetId"
      placeholder="Select an item set"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      class="w-100 expanded-dropdown">
    </p-dropdown>
  </div>

  <div class="dialog-actions mt-5 d-flex justify-content-end">
    <button pButton label="Cancel" class="p-button-text" (click)="cancel()"></button>
    <button pButton label="Confirm" [disabled]="!selectedSetId" (click)="confirmSelection()"></button>
  </div>
</div> 